import React, {useState, useEffect} from  'react';
import api from '../../services/api';
import Select from 'react-select';

export default function ContractsTypesSelect(props){
    
    const [contracts_types, setContractsTypes] = useState([]);
    const [defaultValue, setDefaultValue] = useState(null);
    const [options, setOptions] = useState([]);

    const onChange = (option) => {        
        props.onChange(option.value);
    };

    const getContractsTypes = () => {
        api.get('/contracts_types/index')
        .then(response => {     
            setContractsTypes(response.data.data);                   
        });         
    }

    const getOptions = () => {
        let options = [
            {value: null, label: (props.label ? props.label : '-- Selecione --')} 
        ];        
        contracts_types.map((item, index) => {
            let option = {
                value: item.id,
                label: item.attributes.name
            };
            options.push(option);
        });
        setOptions(options);        
    };   

    useEffect(() => {
        getOptions();
    }, [contracts_types]);   
    
    useEffect(() => {
        options.map((option, index) => {            
            if(option.value == props.defaultValue){
                setDefaultValue(option);                
            }
        });       
    }, [options]);  

    useEffect(() => {  
        getContractsTypes();       
    }, []); 

    return (
        <>
            {(options && defaultValue) && <Select name="contract_type_id" options={options} defaultValue={defaultValue} onChange={onChange} />}
        </>
    );

}